export default __webpack_public_path__ + "static/media/exclamation_triangle.2c3ba8cf.svg";